import { Link, Stack, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { useEffect } from 'react';
import { StyleSheet } from 'react-native';

import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';

export default function NotFoundScreen() {
  const params = useLocalSearchParams();

  useEffect(() => {
    // Log the path that caused the not-found screen to be shown
    console.log('Not-found screen accessed. Path info:', {
      params,
      url: params['url'] || 'unknown',
      timestamp: new Date().toISOString()
    });
  }, [params]);

  return (
    <>
      <Stack.Screen options={{ title: 'Oops!' }} />
      <ThemedView style={styles.container}>
        <ThemedText type="title">This screen does not exist.</ThemedText>
        <Link href="/" style={styles.link}>
          <ThemedText type="link">Go to home screen!</ThemedText>
        </Link>
      </ThemedView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
});
